import { render, staticRenderFns } from "./volunteerManagement.vue?vue&type=template&id=3c236658&scoped=true"
import script from "./volunteerManagement.vue?vue&type=script&lang=js"
export * from "./volunteerManagement.vue?vue&type=script&lang=js"
import style0 from "./volunteerManagement.vue?vue&type=style&index=0&id=3c236658&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c236658",
  null
  
)

export default component.exports